import React from 'react';

const municipios = (props) => {
  return (<>
    <div>
      <label>Municipios:</label>
      <select onChange={props.handleChange}>
        <option value="">Seleccione un municipio</option>
        {props.opciones.map((opcion) => (
          <option key={opcion} value={opcion}>
            {opcion}
          </option>
        ))}
      </select>
    </div>
    <div id="mensaje"> 

    </div>
    </>
  );
};

export default municipios;